import { createFileRoute } from "@tanstack/react-router";
import { seoFor } from "@/lib/i18n/keywordPools";
import Contact from "@/pages/Contact";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/contact")({
  head: () => ({
    meta: [
      { title: "Contact Statlign — Support, Partnerships & Press" },
      { name: "keywords", content: seoFor({ topics: ["contact"] }).meta },
      { name: "description", content: "Get in touch with the Statlign sports intelligence team for support, partnership, press and product enquiries." },
      { property: "og:title", content: "Contact Statlign — Support, Partnerships & Press" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Get in touch with the Statlign sports intelligence team for support, partnership, press and product enquiries." },
      { name: "twitter:title", content: "Contact Statlign — Support, Partnerships & Press" },
      { name: "twitter:description", content: "Get in touch with the Statlign sports intelligence team for support, partnership, press and product enquiries." },
    ],
  }),
  component: () => (
    <MainLayout>
      <Contact />
    </MainLayout>
  ),
});
